import { PartContent as BomPartContent } from 'bom/components';
import { BomPartType } from 'bom/enums';
import { IBomPart } from 'bom/types';
import { PnbPart } from 'quotes/components';
import { BaseCodePart } from 'quotes/elements';
import { QuoteType } from 'quotes/enums';
import { IAttributePartPayload, ICustomerQuotePart, IQuotePart } from 'quotes/types';
import { isPnbPricingEnabled } from 'quotes/utils';

import { PartTypeDiscountContent } from './PartTypeDiscountContent';

interface IProps {
  quotePart: IQuotePart;
  onPartNumberClick?: (quotePart: IQuotePart) => void;
  onEditPartLineClick?: () => void;
  isEditable?: boolean;
  isDeleted?: boolean;
  isSelectPartAllowed?: boolean;
  onAttachParts?: (parts: IAttributePartPayload[]) => Promise<{ newRows: IQuotePart[] }>;
  quoteType?: QuoteType;
}

export const PartContent = ({
  quotePart,
  onPartNumberClick,
  onEditPartLineClick,
  isEditable,
  isDeleted,
  isSelectPartAllowed,
  onAttachParts,
  quoteType = QuoteType.CUSTOMER,
}: IProps) => {
  switch (quotePart.type) {
    case BomPartType.PART:
    case BomPartType.COMPONENT:
      if (
        quoteType === QuoteType.CUSTOMER &&
        isPnbPricingEnabled(quotePart as ICustomerQuotePart)
      ) {
        return (
          <PnbPart
            quotePart={quotePart as ICustomerQuotePart}
            onPartNumberClick={onPartNumberClick as (part: IBomPart) => void}
            isPartEditable={isEditable}
          />
        );
      }

      if (quotePart?.corporatePartConfig?.isBaseCodePart) {
        return (
          <BaseCodePart
            quotePart={quotePart}
            onPartNumberClick={onPartNumberClick}
            isSelectPartAllowed={isSelectPartAllowed}
            onAttachParts={onAttachParts}
          />
        );
      }

      return (
        <BomPartContent
          bomPart={quotePart}
          onPartNumberClick={
            onPartNumberClick ? (bomPart) => onPartNumberClick(bomPart as IQuotePart) : undefined
          }
          onEditPartLineClick={onEditPartLineClick}
          isEditable={isEditable}
          isDeleted={isDeleted}
        />
      );
    case BomPartType.DISCOUNT:
      return (
        <PartTypeDiscountContent
          quotePart={quotePart}
          onPartNumberClick={onPartNumberClick}
          isSelectPartAllowed={isSelectPartAllowed}
          onAttachParts={onAttachParts}
        />
      );
    default:
      return <></>;
  }
};
